import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import {
  FaFileUpload,
  FaTrashAlt,
  FaExclamationCircle,
  FaCheckCircle,
  FaLink,
} from 'react-icons/fa';

import AudioIcon from '~/components/Icons/Files/Audio';
import PdfIcon from '~/components/Icons/Files/Pdf';
import PresentationIcon from '~/components/Icons/Files/Presentation';
import SpreadsheetIcon from '~/components/Icons/Files/Spreadsheet';
import TextIcon from '~/components/Icons/Files/Text';
import VideoIcon from '~/components/Icons/Files/Video';
import WordIcon from '~/components/Icons/Files/Word';

import {
  useStoreRelationshipTopicFiles,
  IStoreRelationshipTopicFile,
} from '~/context/storerelationshiptopicfiles';

import {
  Container,
  FileRow,
  FileContainer,
  FilePreviewWrapper,
  FilePreviewImageWrapper,
  FilePreviewImage,
  FileInfoWrapper,
  FileInfoName,
  FileInfoFileSize,
  FileActions,
  DeleteBtn,
  UrlIcon,
  SuccessIcon,
  ErrorIcon,
} from './styles';

const List = (): JSX.Element => {
  const {
    uploadedStoreRelationshipTopicFiles: storeRelationshipTopicFiles,
    deleteStoreRelationshipTopicFile,
  } = useStoreRelationshipTopicFiles();

  if (!storeRelationshipTopicFiles.length) {
    return (
      <span>
        <FaFileUpload
          style={{ marginLeft: '45%', marginTop: 15 }}
          size={35}
          color="#adadad"
        />
      </span>
    );
  }

  function handleSRTFilePreview(uploadedSRTFile: any): React.ReactNode {
    if (
      uploadedSRTFile.type === 'audio/mp3' ||
      uploadedSRTFile.type === 'audio/mpeg'
    ) {
      return <AudioIcon />;
    }

    if (uploadedSRTFile.type === 'application/pdf') {
      return <PdfIcon />;
    }

    if (
      uploadedSRTFile.type ===
        'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
      uploadedSRTFile.type === 'application/vnd.oasis.opendocument.presentation'
    ) {
      return <PresentationIcon />;
    }

    if (
      uploadedSRTFile.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      uploadedSRTFile.type === 'application/vnd.oasis.opendocument.spreadsheet'
    ) {
      return <SpreadsheetIcon />;
    }

    if (uploadedSRTFile.type === 'text/plain') {
      return <TextIcon />;
    }

    if (
      uploadedSRTFile.type === 'image/gif' ||
      uploadedSRTFile.type === 'video/quicktime' ||
      uploadedSRTFile.type === 'video/mp4'
    ) {
      return <VideoIcon />;
    }

    if (
      uploadedSRTFile.type ===
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      uploadedSRTFile.type === 'application/vnd.oasis.opendocument.text'
    ) {
      return <WordIcon />;
    }

    return (
      <FilePreviewImageWrapper>
        <FilePreviewImage src={uploadedSRTFile.preview} />
      </FilePreviewImageWrapper>
    );
  }

  return (
    <Container>
      {storeRelationshipTopicFiles.map(
        (uploadedStoreRelationshipTopicFile: IStoreRelationshipTopicFile) => (
          <FileRow key={uploadedStoreRelationshipTopicFile.id}>
            <FileContainer>
              <FilePreviewWrapper>
                {handleSRTFilePreview(uploadedStoreRelationshipTopicFile)}
              </FilePreviewWrapper>

              <FileInfoWrapper>
                <FileInfoName>
                  {uploadedStoreRelationshipTopicFile.name}
                </FileInfoName>
                <FileInfoFileSize>
                  {uploadedStoreRelationshipTopicFile.readableSize}
                </FileInfoFileSize>
              </FileInfoWrapper>
            </FileContainer>

            <FileActions>
              {!uploadedStoreRelationshipTopicFile.uploaded &&
                !uploadedStoreRelationshipTopicFile.error && (
                  <CircularProgressbar
                    styles={{
                      root: { width: 24 },
                      path: { stroke: '#7159c1' },
                    }}
                    strokeWidth={10}
                    text={String(uploadedStoreRelationshipTopicFile.progress)}
                    value={uploadedStoreRelationshipTopicFile.progress || 0}
                  />
                )}

              {uploadedStoreRelationshipTopicFile.url && (
                <UrlIcon>
                  <a
                    href={uploadedStoreRelationshipTopicFile.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLink size={20} />
                  </a>
                </UrlIcon>
              )}

              {uploadedStoreRelationshipTopicFile.uploaded && (
                <SuccessIcon>
                  <FaCheckCircle size={24} />
                </SuccessIcon>
              )}
              {uploadedStoreRelationshipTopicFile.error && (
                <ErrorIcon>
                  <FaExclamationCircle size={24} />
                </ErrorIcon>
              )}
              {!!uploadedStoreRelationshipTopicFile.url && (
                <DeleteBtn
                  onClick={() => {
                    deleteStoreRelationshipTopicFile(
                      uploadedStoreRelationshipTopicFile.id,
                    );
                  }}
                >
                  <FaTrashAlt size={24} />
                </DeleteBtn>
              )}
            </FileActions>
          </FileRow>
        ),
      )}
    </Container>
  );
};

export default List;
